




























import { Component, Vue } from 'vue-property-decorator';

  @Component
export default class Hero extends Vue {
    private slide: number = 0;

    private sliding: boolean = false;

    onSlideStart(slide: number) {
      this.sliding = true;
    }

    onSlideEnd(slide: number) {
      this.sliding = false;
    }
}
